import {faPlay} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Button, Image} from 'antd';

import {classNames} from '../../../../../../../util/css';

import * as styles from './preview-group.scss';

type PropsType = {
    imageClassName?: string;
    poster: string | null;
    previewSrc: string;
    videoSrc: string;
};

export function PreviewGroupVideoTile(props: PropsType): JSX.Element {
    const {imageClassName, poster, previewSrc, videoSrc} = props;

    return (
        <div className={styles.ImageGallery_videoTile}>
            <Image
                alt=""
                className={classNames(styles.ImageGallery_image, styles.ImageGallery_videoThumbnail, imageClassName)}
                preview={{maskClassName: styles.ImageGallery_mask}}
                src={previewSrc}
            />
            {!poster && (
                <video
                    className={styles.ImageGallery_videoThumbnailOverlay}
                    muted
                    playsInline
                    preload="metadata"
                    src={videoSrc}
                />
            )}
            <Button className={styles.ImageGallery_videoPlayButton} tabIndex={-1} type="text">
                <FontAwesomeIcon className={styles.ImageGallery_videoPlayIcon} icon={faPlay} />
            </Button>
        </div>
    );
}
